// extracted by css-extract-rspack-plugin
export default {"wrapper":"_6c40bbb9","swiper":"_dae41360","item":"_b01ab3df"};